import React from 'react'
// components
import { TableRow } from '@mui/material'
import { HoverablePopover, Link } from 'components/UI'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// constants
import { Chip, ReviewIcon, TableCell, TEXT_STYLE } from 'themes/views/tables'
// themes
import { EllipsizedText } from 'themes/views/generic'
// types
import { Modals } from 'constants/modals'
import { IField, IPlanObjective } from 'types/graphql'
// utils
import { getEntityStatus } from 'utils/fields'
import { getChipColor, getClosestReview, getOwnedBy, getPlanFromEntity } from 'utils/index'

interface Props {
  data: IPlanObjective
  fields: IField[]
}

const Row: React.FC<Props> = ({ data, fields }) => {
  const { id, description, fieldValueMap, ownedByPosition, ownedByUser } = data

  const { showModal } = useShowModal({ modalType: Modals.OBJECTIVE_MINIMIZED_MODAL })

  const plan = getPlanFromEntity(data)
  const ownedBy = getOwnedBy(ownedByPosition, ownedByUser)
  const closestReview = getClosestReview(data)

  const showObjectiveModal = () => showModal({ id })

  return (
    <TableRow hover>
      <TableCell size={25} withEllipsis>
        <HoverablePopover
          trigger={
            <EllipsizedText onClick={showObjectiveModal} style={TEXT_STYLE}>
              {description}
            </EllipsizedText>
          }>
          {description}
        </HoverablePopover>
      </TableCell>
      <TableCell size={10}>{getEntityStatus(fieldValueMap, fields) || 'N/A'}</TableCell>
      <TableCell size={20} withEllipsis>
        <HoverablePopover
          trigger={
            <EllipsizedText>
              <Link
                href={{
                  pathname: `/plans/${plan.companyId}/edit/${plan.id}`,
                  query: {
                    ...(plan.parentPlanId && { parentId: plan.parentPlanId })
                  }
                }}>
                {plan.name}
              </Link>
            </EllipsizedText>
          }>
          {plan.name}
        </HoverablePopover>
      </TableCell>
      <TableCell size={5}>
        <Chip
          rounded
          icon={closestReview ? <ReviewIcon /> : null}
          label={closestReview ? closestReview.dueDate.format('D MMM YY') : 'No review'}
          chipColor={getChipColor(closestReview?.dueDate, closestReview?.status)}
        />
      </TableCell>
      <TableCell size={20}>{ownedBy}</TableCell>
    </TableRow>
  )
}

export default Row
